'use strict';

/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
angular.module('AcaApp').controller('ForgotPasswordController', [
  '$scope',
  '$location',
  'AuthenticationService',
  'SecurityService',
  'EMAIL_MESSAGES',
  'EXCEPTION',
  function($scope, $location, AuthenticationService, SecurityService, EMAIL_MESSAGES, EXCEPTION){
    this.startParams = function(){
      $scope.step = 1;
      $scope.errorMessage = '';
      $scope.user = {};
      $scope.showEmailRequiered = false;
    };
    $scope.sendEmail = function(enterMailForm){
      $scope.errorMessage = '';
      if(enterMailForm.$valid){
        SecurityService.forgotPassword($scope.user).then(function(){
          $scope.step = 2;
        },
        function(error){
          if(error.data.error.frontend_code === EXCEPTION.BADLOGIN){
            $scope.step = 2;
          }
          else{
            $scope.errorMessage = (error.data.error.frontend_message || undefined);
          }
        });
      }
      else{
        if(enterMailForm.email.$error.email){
          $scope.showEmailRequiered = false;
          $scope.errorMessage = EMAIL_MESSAGES.EMAILFORMAT;
        }
        else{
          $scope.eventShowEmailRequiered();
        }
      }
    };
    $scope.backHome = function(){
      $location.path('/login');
    };
    $scope.backStep1 = function(){
      $scope.step = 1;
    };
    $scope.eventShowEmailRequiered = function(){
      $scope.errorMessage = '';
      $scope.showEmailRequiered = true;
    };
    this.startParams();
  }
]);
